import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  FormLayout,
  TextField,
  Button,
  Banner,
  BlockStack,
  Text,
  Box,
} from '@shopify/polaris';

import { useAdminAuth } from '../../providers/AdminAuthProvider';

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login, error, isAuthenticated } = useAdminAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // Redirect if already authenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const success = await login(username, password);
    setIsLoading(false);
    if (success) {
      navigate('/admin/dashboard');
    }
  };

  return (
    <Box padding="800" background="bg-surface-secondary" minHeight="100vh">
      <div style={{ maxWidth: '400px', margin: '0 auto', paddingTop: '100px' }}>
        <BlockStack gap="400">
          <Text variant="headingXl" as="h1" alignment="center">
            Admin Panel
          </Text>
          <Text variant="bodyMd" as="p" alignment="center" tone="subdued">
            Jambofy Free Shipping Bar
          </Text>
          
          <Card>
            <form onSubmit={handleSubmit}>
              <BlockStack gap="400">
                {error && (
                  <Banner tone="critical">
                    {error}
                  </Banner>
                )}
                
                <FormLayout>
                  <TextField
                    label="Username"
                    value={username}
                    onChange={setUsername}
                    autoComplete="username"
                    autoFocus
                  />
                  <TextField
                    label="Password"
                    type="password"
                    value={password}
                    onChange={setPassword}
                    autoComplete="current-password"
                  />
                </FormLayout>
                
                <Button
                  variant="primary"
                  submit
                  loading={isLoading}
                  fullWidth
                >
                  Sign In
                </Button>
              </BlockStack>
            </form>
          </Card>
        </BlockStack>
      </div>
    </Box>
  );
}
